import AddIcon from "@mui/icons-material/Add";
import { Box, Fab } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addProviderPractice, changePracticeAvailability, deleteProviderPractice, removeProviderPracticeById, updateProviderPracticeAvailability } from "../../../actions/providedServices";
import snackbarUtils from "../../../utils/snackbarUtils";
import ConfirmDialog from "../dialog/confirmDialog";
import ProviderProvidedServiceFormContainer from "./providerProvidedServiceFormContainer";
import ProviderProvidedServiceTable from "./providerProvidedServiceTable";
import ProviderServicePracticeFormContainer from "./providerServiceForm/providerServicePracticeFormContainer";

const ProviderProvidedServiceContainer = () => {

  const dispatch = useDispatch();
  const loadingDelete = useSelector((state) => state.providedServices.deleteProviderPractice.isFetching);
  const loadingAdd = useSelector((state) => state.providedServices.addProviderPractice.isFetching);

  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openServiceForm, setOpenServiceForm] = useState(false);
  const [serviceToEdit, setServiceToEdit] = useState(null);

  const handleEdit = (service) => {
    setServiceToEdit(service);
    setOpenServiceForm(true);
  }


  const handleDelete = () => {
    dispatch(deleteProviderPractice(serviceToDelete.artId, serviceToDelete.id)).then(() => {
      dispatch(removeProviderPracticeById(serviceToDelete.id));
      setServiceToDelete(null);
      setOpenDeleteDialog(false);
    })
  }

  const handleOpenDeleteDialog = (service) => {
    setServiceToDelete(service);
    setOpenDeleteDialog(true);
  }

  const handleCloseProviderServiceForm = () => {
    setOpenServiceForm(false);
    setServiceToEdit(null);
  }
  const handleSubmitProviderServiceForm = (values) => {
    if (serviceToEdit) {
      dispatch(changePracticeAvailability(values.art, values.id, values.habilitada)).then(() => {
        snackbarUtils.success("Prestación actualizada correctamente");
        handleCloseProviderServiceForm();
        dispatch(updateProviderPracticeAvailability(values.id, values.habilitada));
      })
    } else {
      dispatch(addProviderPractice(values)).then(() => {
        snackbarUtils.success("Prestación agregada correctamente");
        handleCloseProviderServiceForm();
      })
    }

  }

  return (
    <>
      <ProviderProvidedServiceFormContainer />
      <ProviderProvidedServiceTable handleDelete={handleOpenDeleteDialog} handleEdit={handleEdit} />
      {
        <Box
          sx={{
            margin: "5px 20px",
            display: "flex",
            justifyContent: "flex-end",
          }}>
          <Fab
            onClick={() => handleEdit()}
            color="primary"
            aria-label="add">
            <AddIcon />
          </Fab>
        </Box>
      }
      <ConfirmDialog
        open={openDeleteDialog}
        handleClose={() => {
          setOpenDeleteDialog(false);
          setServiceToDelete(null);
        }}
        handleConfirm={() => handleDelete()}
        title="¿Está seguro que desea Eliminar esta prestación?"
        text={`Al hacerlo, la misma ya no será accesible para el Prestador`}
        warningText="Advertencia: Esta acción no se podrá revertir."
        loading={loadingDelete}
      />
      <ProviderServicePracticeFormContainer
        open={openServiceForm}
        handleSubmit={handleSubmitProviderServiceForm}
        handleClose={handleCloseProviderServiceForm}
        serviceToEdit={serviceToEdit}
        loading={loadingAdd}
      />
    </>
  )

}

export default ProviderProvidedServiceContainer;